<template>
	<div class="list-group no-border border-radius-2 mb-3">
		<div class="list-group-item list-group-item-secondary" @click="selectItem()">
			<div class="row">
				<div class="col-md-8">
					<strong>{{$datetime.getLocaleDateStringFromTimestamp(placement.from, isUTC=true)}}
					{{$datetime.getLocaleTimeStringFromTimestamp(placement.from, isUTC=true)}} -
					{{$datetime.getLocaleTimeStringFromTimestamp(placement.to, isUTC=true)}} | {{placement.ttroom.name}}<template v-if="studentYears"> | {{$t('year')}} {{studentYears}}</template>  </strong>
				</div>
				<div class="col-md-4 text-right">
					<template v-if="placement.students.length==1">
						{{$t('{n}-student' , {n: placement.students.length})}}
					</template>
					<template v-else>
						{{$t('{n}-students' , {n: placement.students.length})}}
					</template>
					<b-button v-if="$UserSession.hasPriv('MESSAGES')" variant="light" class="btn-sm" @click.stop="newMessage(placement.students)">{{ $t('message') }}</b-button>
				</div>
			</div>
		</div>
		<template v-if="selected">
			<div
				class="list-group-item"
				v-for="(student, index) in placement.students"
				v-bind:key="`${placement.id}_${index}`"
			>
				<Avatar
					class="avatar float-left mr-4 mb-0 lg:mb-0"
					:userId="student.id"
				/>
				<div class="mr-4 mb-0">
					<h3 class="mb-0">
						{{student.displayname}}
					</h3>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import Avatar from "../Avatar.vue";
export default {
	components: {
		Avatar
	},
    props: {
        placement: Object
    },
    data() {
    	return {
    		selected: false
    	}
    },
	mounted() {
	},
	methods: {
		selectItem: function(){
			this.selected = !this.selected;
		},
		newMessage: function(recipients){
			this.$emit('newMessageCallback' , recipients);
		}
	},
	computed: {
		studentIds: function(){
			return this.placement.students.map(item => {
				return item.id
			})
		},
		studentYears: function(){
			const years = [...new Set(this.placement.students.map(item => item.year).filter(year => year !== null && year !== undefined))];
			years.sort((a, b) => a - b);
			return years.join(', ');
		}
	}
};
</script>
